import { useEffect } from 'react'

import { useGlobalContext } from '../../../context/ContextGlobal'
import { TryCatch } from '../../../utils/general'
import { getDocumentsWithQuery } from '../../../firebase/firestore'
import useCollaborator from './useCollaborator'

const useCollaboratorSelectPlan = () => {
  const { user, setAlerts, setLoading, loading, dataContext, setDataContext } = useGlobalContext()

  const { Authentication } = useCollaborator()

  const getData = async () => {
    await Authentication()

    const getAllPlans = await getDocumentsWithQuery('plans', 'typePlan', '==', 'collab')

    setDataContext({ plans: getAllPlans })
  }

  const FetchGetData = async () => {
    await TryCatch(getData, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetData()
  }, [])

  return { user, loading, FetchGetData, dataContext }
}

export default useCollaboratorSelectPlan
